import CurrentCaseRequired from "../components/ui/current-case-required.js";
import EstateSummaryExport from "../components/ui/estate-summary-export.js";
import CaseDatabaseCheck from "../components/ui/case-database-check.js";

export default function EstateSummaryExportPage() {
    return (
        <CaseDatabaseCheck>
        <CurrentCaseRequired>
        <EstateSummaryExport />
        </CurrentCaseRequired>
        </CaseDatabaseCheck>
    );
}
